export default ({}) => ({
    xAxis: {
        startOnTick: false,
        endOnTick: false,
    },
});
